// ============================================================================
// Timer Start
// ============================================================================

class FlexibleTimer {
  constructor(
    element,
    callback
  ) {
    this.callback = callback; // Function to call when the timer completes
    this.remainingTime = 0; // Time left in milliseconds
    this.startTime = 0; // Timestamp when the timer starts or resumes
    this.timerId = null; // Reference to the timer
    this.isRunning = false; // Timer state
    this.totalDuration = 0; // Total duration of the timer
    this.progressBar = typeof element === "string" ? document.querySelector(element) : element;
    this.updateProgressBar();
  }

  // Start or resume the timer
  start(duration = null) {
    if (duration !== null) {
      this.remainingTime = duration;
      this.totalDuration = duration; // Save the total duration for progress calculations
    }

    // console.log(`start this.remainingTime = ${this.remainingTime}`);
    if (this.remainingTime <= 0) {
      // this.end();
      // console.error("Timer duration must be greater than 0");
      return;
    }

    if (this.isRunning) {
      // console.warn("Timer is already running");
      return;
    }

    // console.info('timer start');

    this.startTime = Date.now();
    this.isRunning = true;

    this.timerId = setInterval(() => {
      const remaining = this.getRemainingTime();
      if (remaining <= 0) {
        this.end();
      } else {
        // console.log(`remaining = ${remaining}`);
        // console.log(`this.remainingTime = ${this.remainingTime}`);
        this.updateProgressBar();
      }
    }, 100); // Update the progress bar every 100ms
  }

  end() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }

    this.isRunning = false;
    this.remainingTime = 0;

    if (this.callback) {
      this.callback();
    }

    this.updateProgressBar();
  }

  // Pause the timer
  pause() {
    if (!this.isRunning) {
      // console.warn("Timer is not running");
      return;
    }

    // console.info('timer pause');

    clearInterval(this.timerId);
    this.isRunning = false;
    this.remainingTime -= Date.now() - this.startTime;
    this.updateProgressBar();
  }

  // Reset the timer with a new duration
  reset(newDuration) {
    this.pause(); // Stop the current timer
    this.remainingTime = newDuration;
    this.totalDuration = newDuration;
    this.updateProgressBar();
  }

  // Check the remaining time in milliseconds
  getRemainingTime() {
    if (this.isRunning) {
      return this.remainingTime - (Date.now() - this.startTime);
    }
    return this.remainingTime;
  }

  // Stop the timer completely
  stop() {
    clearInterval(this.timerId);
    this.isRunning = false;
    this.remainingTime = 0;
    this.updateProgressBar();
  }

  // Update the width of the progress bar
  updateProgressBar() {
    if (this.progressBar) {
      const remaining = this.getRemainingTime();
      let percentage = 0;

      if (remaining > 0) {
        percentage = ((this.totalDuration - remaining) / this.totalDuration) * 100;
      }

      this.progressBar.style.width = `${percentage}%`;
    }
  }
}

// ============================================================================
// Timer End
// ============================================================================

// ============================================================================
// Slideshow Start
// ============================================================================

// ----------------------------------------------------------------------------
// Slideshow Variables
// ----------------------------------------------------------------------------

const SLIDESHOW_AUTO_DELAY = 5000;
const SLIDESHOW_AUTO_DELAY_INTERACTED = 10000;
const SLIDESHOW_AUTO_DELAY_MIN = 2000;

// Swipe detection variables
const SWIPE_THRESHOLD = 1; // Minimum movement to consider it a swipe

// ----------------------------------------------------------------------------
// Slideshow Class
// ----------------------------------------------------------------------------

class Slideshow {
  constructor(element) {
    // ----------------------------------------------------------------------------
    // Slideshow Class Variables
    // ----------------------------------------------------------------------------
    
    this.interacted = false;

    // Bind methods to ensure correct context
    this.onSlideshowSlideChange = this.onSlideshowSlideChange.bind(this);
    this.onTimerComplete = this.onTimerComplete.bind(this);
    this.timerStart = this.timerStart.bind(this);
    this.onSlideshowInit = this.onSlideshowInit.bind(this);

    this.elementSlideshowWrap = element;
    this.elementSlideshowInteract = element.querySelector('.slideshow-interact');
    this.elementSlideshow = element.querySelector('.slideshow-items');
    this.elementSlideshowPrev = element.querySelector('.slideshow-prev');
    this.elementSlideshowNext = element.querySelector('.slideshow-next');

    this.elementSlideshowButtons = [
      this.elementSlideshowPrev,
      this.elementSlideshowNext
    ];

    // ----------------------------------------------------------------------------
    // Slideshow Swipe Detection Variables
    // ----------------------------------------------------------------------------

    this.isInteraction = false; // Tracks if a click or press is active
    this.interactionXInit = 0; // Starting X position of a touch/mouse event
    this.isInteractionSwipe = false; // Tracks whether a swipe is in progress

    // ----------------------------------------------------------------------------
    // Slideshow FlexibleTimer Instance
    // ----------------------------------------------------------------------------

    // this.timer = null;

    // Initialize the FlexibleTimer
    this.timer = new FlexibleTimer(element.querySelector('.slideshow-progress'), this.onTimerComplete);

    // ----------------------------------------------------------------------------
    // Slideshow Siema Instance
    // ----------------------------------------------------------------------------

    // Initialize Siema with bound methods
    this.slideshowSiema = new Siema({
      // selector: '.slideshow-items',
      selector: this.elementSlideshow,
      duration: 500,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 50,
      loop: true,
      rtl: false,
      onInit: this.onSlideshowInit,
      onChange: this.onSlideshowSlideChange.bind(this)
    });

    // ----------------------------------------------------------------------------
    // Event Listeners
    // ----------------------------------------------------------------------------

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // Event Listeners - Binds
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    // Bind the method to retain `this` context
    this.isEventOnElement = this.isEventOnElement.bind(this);

    this.slideshowTimerStart = this.slideshowTimerStart.bind(this);
    this.slideshowTimerPause = this.slideshowTimerPause.bind(this);

    this.handleInteractStart = this.handleInteractStart.bind(this);
    this.handleInteractMove = this.handleInteractMove.bind(this);
    this.handleInteractEnd = this.handleInteractEnd.bind(this);
    this.handleInteractEndTouch = this.handleInteractEndTouch.bind(this);

    this.handleButtonAction = this.handleButtonAction.bind(this);

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // Event Listeners - Wrap
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    this.elementSlideshowInteract.addEventListener('mouseover', (event) => {
      // alert("mouseover");
      if (this.isTouchDevice() || !this.isEventOnElement(this.elementSlideshowInteract, event)) {
        return;
      }

      // alert("mouseover");
      this.slideshowTimerPause();
    });

    this.elementSlideshowInteract.addEventListener('mouseout', (event) => {
      if (!this.isEventOnElement(this.elementSlideshowInteract, event)) {
        return;
      }

      // alert("mouseout");
      this.handleInteractEnd(event);
      this.slideshowTimerStart();
    });

    // this.elementSlideshowInteract.addEventListener('focusin', (event) => {
    // });

    // this.elementSlideshowInteract.addEventListener('focusout', (event) => {
    // });

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // Event Listeners - Swipe Detection
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    // Attach event listeners for swipe detection
    this.elementSlideshow.addEventListener('touchstart', this.handleInteractStart);
    this.elementSlideshow.addEventListener('touchmove', this.handleInteractMove);
    this.elementSlideshow.addEventListener('touchend', this.handleInteractEndTouch);

    this.elementSlideshow.addEventListener('mousedown', this.handleInteractStart);
    this.elementSlideshow.addEventListener('mousemove', this.handleInteractMove);
    // elementSlideshow.addEventListener('mouseup', this.handleInteractEnd);

    this.elementSlideshow.addEventListener('click', this.handleInteractEnd);
    // this.elementSlideshowPrev.addEventListener('focusin', this.handleInteractStart);
    // this.elementSlideshowNext.addEventListener('focusout', this.handleInteractEnd);
    // this.elementSlideshow.addEventListener('focusout', (event) => {
    //   const newFocusTarget = event.relatedTarget;
    //   if (!this.elementSlideshow.contains(newFocusTarget)) {
    //     // Focus has completely left this.elementSlideshow and its children
    //     this.handleInteractEnd();
    //   }
    // });

    for(const elem of this.elementSlideshowWrap.querySelectorAll('a')) {
      elem.addEventListener('focusin', () => {
        // alert("mouseover");
        // if (this.isTouchDevice() || !this.isEventOnElement(this.elementSlideshowInteract, event)) {
        //   return;
        // }
  
        // alert("mouseover");
        this.slideshowTimerPause();
      });
      elem.addEventListener('focusout', (event) => {
        const newFocusTarget = event.relatedTarget;
        if (!this.elementSlideshowWrap.contains(newFocusTarget)) {
          // if (!this.isEventOnElement(this.elementSlideshowInteract, event)) {
          //   return;
          // }
    
          // alert("mouseout");
          this.handleInteractEnd(event);
          this.slideshowTimerStart();
        }
      });
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // Event Listeners - Buttons
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    this.elementSlideshowPrev.addEventListener('click', this.handleButtonAction(() => this.slideshowSiema.prev()));
    this.elementSlideshowNext.addEventListener('click', this.handleButtonAction(() => this.slideshowSiema.next()));

    this.elementSlideshowButtons.forEach((elementSlideshowButton) => {
      elementSlideshowButton.addEventListener('touchstart', () => {
        this.slideshowTimerPause();
      });
    });

    // this.elementSlideshowInteract.addEventListener('touchstart', () => {
    //   this.slideshowTimerPause();
    // });
    this.elementSlideshowInteract.addEventListener('touchend', () => {
      this.slideshowTimerStart();
    });

    // this.elementSlideshowInteract.addEventListener('contextmenu', () => {
    //   alert("contextmenu");
    // });

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // Event Listeners - Visibility
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    // Ensure Timer On Load Begin (Mobile Issue)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        // Page is now active
        this.slideshowTimerStart(SLIDESHOW_AUTO_DELAY);
      } else {
        // Page is hidden, optionally pause the timer
        this.slideshowTimerPause();
      }
    });
  };

  // ----------------------------------------------------------------------------
  // Slideshow Timer
  // ----------------------------------------------------------------------------

  timerStart(duration = 0) {
    if (!this.timer) {
      return;
    }

    if (duration > 0) {
      this.timer.start(duration);
      return;
    }

    if (this.timer.remainingTime > 0) {
      if (this.timer.remainingTime < SLIDESHOW_AUTO_DELAY_MIN) {
        this.timer.remainingTime = SLIDESHOW_AUTO_DELAY_MIN;
      }
      this.timer.start();
    }
    else {
      this.timer.start(SLIDESHOW_AUTO_DELAY);
      this.interacted = false;
    }
  }

  timerPause() {
    if (this.timer) {
      this.timer.pause();
    }
  }

  onTimerComplete() {
    // console.log("Timer completed!");
    this.slideshowSiema.next();
    this.timerStart();
  }

  // ----------------------------------------------------------------------------
  // Slideshow Init and Change
  // ----------------------------------------------------------------------------

  onSlideshowInit() {
    this.elementSlideshow.classList.remove('slideshow-items--init');
    this.timerStart();
  }

  onSlideshowSlideChange() {
    // console.log(`Slide Selector: ${this.slideshowSiema.config.selector}, Current Slide: ${this.slideshowSiema.currentSlide}`);
  }

  // ----------------------------------------------------------------------------
  // Slideshow Interact
  // ----------------------------------------------------------------------------

  onSlideshowInteract() {
    this.interacted = true;

    if (this.timer) {
      this.timer.reset(SLIDESHOW_AUTO_DELAY_INTERACTED);
    }
  }

  slideshowButtonAction(action) {
    this.onSlideshowInteract();

    action(); // Perform the action (e.g., `slideshowSiema.prev()` or `slideshowSiema.next()`)
  }

  slideshowTimerPause() {
    // console.log('mouseover wrap');
    this.timerPause();
  }

  slideshowTimerStart(duration = 0) {
    // console.log('mouseout wrap');
    if (duration > 0) {
      this.timerStart(duration);
    }
    this.timerStart();
  }

  // ----------------------------------------------------------------------------
  // Slideshow Swipe Detection
  // ----------------------------------------------------------------------------

  setIsInteractionSwipe(value) {
    this.isInteractionSwipe = value; // Set swipe status

    // console.log(`this.isInteractionSwipe = ${this.isInteractionSwipe}`);

    if (this.isInteractionSwipe) {
      this.elementSlideshowWrap.classList.add('slideshow-items--swipe');
    } else {
      this.elementSlideshowWrap.classList.remove('slideshow-items--swipe');
    }
  }

  getEventInteract(event) {
    return event.touches ? event.touches[0] : event;
  }

  // Detect the start of a interaction event
  handleInteractStart(event) {
    // Update interacting state
    if (event.type === 'mousedown' || event.type === 'touchstart') {
      this.isInteraction = true;
      this.interactionXInit = this.getEventInteract(event).clientX;
    }

    // console.log('[Swipe] Start');
    this.setIsInteractionSwipe(false);

    this.slideshowTimerPause();
  }

  // Detect the movement during a touch/mouse event
  handleInteractMove(event) {
    if (!this.isInteraction || this.isInteractionSwipe) return; // Only proceed if an interaction, and not a swipe, is active

    const deltaX = this.getEventInteract(event).clientX - this.interactionXInit;

    // Check if the movement is more horizontal than vertical and exceeds the threshold
    if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
      // console.log('[Swipe] Move');
      this.setIsInteractionSwipe(true);
    }
  }

  isInteractLink(event) {
    let target = event.target;

    // Traverse up the DOM to check for parent <a> tag
    while (target && target !== this.elementSlideshow) {
      if (target.tagName.toLowerCase() === 'a') {
        return true; // Exit the while after preventing the click
      }

      target = target.parentElement;
    }

    return false;
  }

  handleSwipeEnd(event) {
    // Prevent clicks on links if a swipe occurred
    if (this.isInteractionSwipe) {
      if (this.isInteractLink(event)) {
        event.preventDefault(); // Prevent default click behavior
        event.stopPropagation(); // Stop the event from propagating further

        // console.warn('Click on link prevented');
      }

      this.setIsInteractionSwipe(false);

      // console.warn('No clickable link detected');
    }
  }

  // Detect the end of a touch/mouse event
  handleInteractEnd(event) {
    // console.log('[Swipe] End');
    this.handleSwipeEnd(event);

    if (this.isInteraction) {
      this.onSlideshowInteract();
    }

    this.isInteraction = false;
  }

  // ----------------------------------------------------------------------------
  // Event Listeners
  // ----------------------------------------------------------------------------

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // Event Listeners - Wrap
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  isEventOnElement(element, event) {
    return !element.contains(event.relatedTarget);
  }

  // Utility function to check for touch support
  isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  handleInteractEndTouch(event) {
    if (!this.isEventOnElement(elementSlideshowInteract, event)) {
      return;
    }
    // alert("touchend");

    this.handleInteractEnd(event);
    this.slideshowTimerStart();
  }

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  // Event Listeners - Buttons
  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  handleButtonAction(action) {
    return () => {
      this.slideshowButtonAction(() => action());

      if (!this.isTouchDevice()) {
        return;
      }

      this.slideshowTimerStart();
    };
  }
}

// ============================================================================
// Slideshow End
// ============================================================================

// ============================================================================
// Slideshow Setup Begin
// ============================================================================

const elementSlideshowWraps = document.querySelectorAll('.slideshow');
let slideshows = []

for (const elementSlideshowWrap of elementSlideshowWraps) {
  slideshows.push(new Slideshow(elementSlideshowWrap));
  // break;
  // console.log("Total slideshows: ", slideshows.length);
}

// ============================================================================
// Slideshow Setup End
// ============================================================================
